import { cn } from '@/lib/utils';

export default function ResqlyCard({ children, className, elevated = false, ...props }) {
  return (
    <div
      className={cn(
        'rounded-[var(--resqly-radius-lg)] border border-[var(--resqly-border)] bg-[var(--resqly-surface)]',
        elevated
          ? 'shadow-[var(--resqly-shadow-md)]'
          : 'shadow-[var(--resqly-shadow-sm)]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
